<template>
    <button @click="$emit('click')" :type="type" class="flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
        <div class="items-center">
            <slot name="icon"></slot><slot></slot>
        </div>
    </button>
</template>

<script>
export default {
    name: "ButtonSecondary",
    props: {
        type: {
            default: "button",
            type: String,
        }
    }
}
</script>

<style scoped>

</style>

